import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=4f28d99f&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=4f28d99f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f28d99f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f28d99f')) {
      api.createRecord('4f28d99f', component.options)
    } else {
      api.reload('4f28d99f', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=4f28d99f&scoped=true&", function () {
      api.rerender('4f28d99f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/comp/PopupBox.vue"
export default component.exports